import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

// import { AdsenseModule } from 'ng2-adsense'

import { SharedModule } from '../shared/shared.module'
import { MoviesRoutingModule } from './movies-routing.module'

import { MovieCardComponent } from './movie-card/movie-card.component'
import { MovieTicketComponent } from './movie-ticket/movie-ticket.component'
import { MovieDetailComponent } from './movie-detail/movie-detail.component'
import { MovieListComponent } from './movie-list/movie-list.component'

import { MovieService } from './shared/movie.service'
import { Movie, Theatre, Showtime } from './shared/movie.model'

import { MovieBannerPipe } from './shared/movie-banner.pipe';
import { MovieShowtimeListComponent } from './movie-showtime-list/movie-showtime-list.component'

import { YoutubePlayerModule } from '../youtube-player/youtube-player.module'

@NgModule({
  imports: [
    SharedModule,
    MoviesRoutingModule,
    YoutubePlayerModule
    // AdsenseModule,
  ],
  exports: [
    MovieCardComponent,
    MovieTicketComponent,
    MovieListComponent
  ],
  declarations: [
    MovieCardComponent,
    MovieTicketComponent,
    MovieDetailComponent,
    MovieListComponent,
    MovieBannerPipe,
    MovieShowtimeListComponent,
  ],
  providers: [ MovieService ]
})
export class MoviesModule { }


export { MovieService, Movie, Theatre, Showtime}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movies.module.ts